import React, { useEffect, useState } from "react";
import { collection, query, onSnapshot, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import useAuth from "../Auth/useAuth";


const StudentFields = () => {
  const {userType } = useAuth();
  const [openModal,setOpenModal] = useState("");
  const [closemodal,setCloseModal] = useState("");
  const [list, setList] = useState([]);
  const [date,setDate] = useState("");
  const [values ,setValues]= useState([]);
  const [standard,setStandard] = useState("");
  const [classSection,setClassSection] = useState("");

  useEffect(() => {
    const q = query(collection(db, "admissionStudentList"));
    onSnapshot(q, (querySnapshot) => {
      let studentArray = [];
      querySnapshot.forEach((doc) => {
        studentArray.push({id:doc.id,...doc.data()});
      });
      setList(studentArray);
    });
  }, []);

  const newArray=[];
  const handleChange = (e)=> {
    let studentRoll=e.studentRollNumber;
     setValues(values.concat(studentRoll))
  }

  const handlePresent = (e)=> {
    let studentRoll=e.studentRollNumber;

    for(let i=0;i<values.length;i++){

      setValues(values.filter((e)=>e!==studentRoll))

    }
  }
  // console.log(absent);
  
  // let tempArray = []
  // tempArray=(list?.filter((item) => item?.studentRollNumber === absent ));
  
  let tempArr=[]
  tempArr=(list?.filter((item) => item?.studied === standard && item?.classSection === classSection));
  
  var presentArray=tempArr
  var absentArray=values
 
  const presentList=presentArray.filter((item)=>!absentArray.includes(item.studentRollNumber))

  const absentList=presentArray.filter((item)=>absentArray.includes(item.studentRollNumber))


  // console.log(absentList);


  const handleAttendance = async () => {
    await addDoc(collection(db, "attendanceLists"), {
      present : presentList ,
      absent : absentList,
      standard,  
      classSection,
      date:serverTimestamp(),
      userType
    }).then(()=>{
      window.location.reload(false)
    })
  };


  return (
    
    <div className="p-5  min-h-screen"> 
      <div className="grid lg:grid-cols-3 grid-cols-2 pl-5 pr-5 ">
    <div className="w-full max-w-sm p-2">
                <div className="md:flex md:items-center ">
                  <div className="md:w-1/4">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Class
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select
                       value={standard}
                       onChange={(e) => {
                      setStandard(e.target.value);
                               }}
                   className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                       >
                         <option value="null"> select</option>
                      <option value="1">Class I</option>
                      <option value="2">Class II</option>
                      <option value="3">Class III</option>
                      <option value="4">Class IV</option>
                      <option value="5">Class V</option>
                      <option value="6">Class VI</option>
                      <option value="7">Class VII</option>
                      <option value="8">Class VIII</option>
                      <option value="9">Class IX</option>
                      <option value="10">Class X</option>
                      <option value="11">Class XI</option>
                      <option value="12">Class XII</option>
                  </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm p-2">
                <div className="md:flex md:items-center ">
                  <div className="md:w-1/4">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Section
                    </label>
                    </div>
                    <div className="md:w-1/2">
                   <select
                   value={classSection}
                   onChange={(e) => {
                  setClassSection(e.target.value);
                           }}
              className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      <option value="null"> select</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                      <option value="F">F</option>
                    </select></div></div></div>
            </div>  
      <h1 className="text-left mb-4 ml-2 text-3xl font-semibold">
        Student List
      </h1>
   
      <div className="flex items-center ">
      <div className=" relative  mb-3 xl:w-96">
       <input type="date"
        className=" block w-64 px-3 py-1.5 text-base  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        placeholder="Select a date" 
        value={date}
        onChange={(e)=>setDate(e.target.value)}
        />
      </div>
      </div>

      <table className="w-full md:hidden text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
            <th className="py-3 text-sm ">Roll No.</th>
            <th className="py-3 text-sm ">Full Name</th>
            <th className="py-3 text-sm ">Attendance</th>
            <th className="py-3 text-sm ">Current Data</th>
          </tr>
        </thead>   
        <tbody>
            {[...tempArr]
               .sort((a, b) => a.studentRollNumber - b.studentRollNumber)
               .map((item, index) =>  (
              <tr className="border-b" key={index}>
              <td className="py-3 hidden px-2 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {++index}
              </td>
                <td className="py-3 px-2 lg:px-10 text-sm font-medium text-gray-900 border-r">
              {item.studentRollNumber}
            </td>
              <td className="py-3 px-2 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {item.fullName}
              </td>
              <td className="py-3 text-sm font-medium text-gray-900 border-r">
              {values.find((elem)=>elem===item.studentRollNumber)?  <button  className="text-white bg-green-600 px-1 rounded-md " onClick={()=>handlePresent(item)}>Present</button>:<button className="text-white bg-red-600 px-1 rounded-md " onClick={()=>handleChange(item)}>Absent</button>   }
              </td>
              <td className="py-3 px-2 lg:px-10 text-sm font-medium text-gray-900 border-r">
             {values.find((elem)=>elem===item.studentRollNumber)?  <span  className="text-red-600">Absent</span>:<span  className="text-green-600">Present</span>}
             </td>
            </tr>
            ))}
          </tbody>
      </table>

      <table className="w-full hidden md:block text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
            <th className="py-3 text-sm md:px-6 lg:px-10 "> Sl No.</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Class</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Roll No.</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Full Name</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Student Code </th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Gender</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Date</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Attendance</th>
            <th className="py-3 text-sm md:px-6 lg:px-10 ">Current Data</th>
          </tr>
        </thead>
    

        <tbody>
            {[...tempArr]
               .sort((a, b) => a.studentRollNumber - b.studentRollNumber)
               .map((item, index) =>  (
              <tr className="border-b" key={index}>
              <td className="py-3 md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {++index}
              </td>
              <td className="py-3 md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
               {item.studied}{item.classSection}
               </td>
                <td className="py-3  md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
              {item.studentRollNumber}
            </td>
              <td className="py-3  md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {item.fullName}
              </td>
              <td className="py-3 md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {item.studentIdNumber}
              </td>
              <td className="py-3 md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {item.gender}
              </td>
              <td className="py-3 md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
                {date.split('-').reverse().join('-')}
              </td>
              <td className="py-3 text-sm font-medium text-gray-900 border-r">
              {values.find((elem)=>elem===item.studentRollNumber)?  <button  className="text-white bg-green-600 px-1 rounded-md " onClick={()=>handlePresent(item)}>Present</button>:<button className="text-white bg-red-600 px-1 rounded-md " onClick={()=>handleChange(item)}>Absent</button>   }
              </td>
              <td className="py-3 px-2 md:px-6 lg:px-10 text-sm font-medium text-gray-900 border-r">
             {values.find((elem)=>elem===item.studentRollNumber)?  <span  className="text-red-600">Absent</span>:<span  className="text-green-600">Present</span>}
             </td>
            </tr>
            ))}
          </tbody>
   
      </table>

      <div className="mt-10">
      <div className="mt-4 ">
        <button
          className="w-24 h-8 bg-blue-400  text-2xl text-white font-semibold"
          onClick={() =>
            setOpenModal(() => {
              setCloseModal(false);
              setOpenModal(true);
            })
          }
        >
          Submit
        </button>
      </div>
      </div>
    {openModal && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" >
      <div className="fixed z-0 grid grid-rows-3 justify-center inset-0 overflow-y-auto p-20">
        <div className=" bg-white rounded-md row-span-2">
         <div className=""> <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
            <th className="py-3 hidden">Sl No.</th>
            <th className="py-3 ">Roll No.</th>
            <th className="py-3 ">Full Name</th>
            <th className="py-3 hidden">Student Code </th>
          </tr>
        </thead>
          <tbody>
            { [...absentList].sort((a, b) => a.studentRollNumber - b.studentRollNumber)
               .map((item,index)=> (
              <tr className="border-b" key={index}>
              <td className="py-3 hidden px-10 text-sm font-medium text-gray-900 border-r">
                {++index}
              </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              {item.studentRollNumber}
            </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.fullName}
              </td>
              <td className="py-3 hidden px-10 text-sm font-medium text-gray-900 border-r">
                {item.studentIdNumber}
              </td>
            </tr>
            ))}
          </tbody>
          </table> </div>
          
        <div className="flex justify-between mt-32">
          <div className="md:ml-10 ml-4">
           <button
             className="bg-green-400 text-xl p-1 md:text-2xl text-white font-semibold rounded-lg"
            onClick={handleAttendance}
           >
             Submit
           </button>
           </div>
           <div className="md:mr-10 mr-4">
            <button 
            onClick={() =>
              setOpenModal(() => {
                setCloseModal(true);
                setOpenModal(false);
              })
            }
              className="bg-red-400 text-xl p-1 md:text-2xl text-white font-semibold rounded-lg"
              >Cancel</button>
           </div>
         </div>
        </div>
      </div>
     
      </div>    
    )
    }
    
    </div>
  );
};

export default StudentFields;
